import React, { useEffect, useState } from "react";
import { LockOutlined, UserOutlined } from "@ant-design/icons";
import { Button, Form, Input, notification, Row } from "antd";
import IMAGES from "../../const/Image";
import ReCAPTCHA from "react-google-recaptcha";
import { ForgotPassword } from "../../const/ForgotPassword/ForgotPassword";
import { Navigate, useNavigate } from "react-router-dom";
// import createService from "./createService";
import { createService, generateSessionToken } from "../../Services/AppoinmentServices";
import uuid from 'react-uuid';
import { login } from "../../Services/AuthServices";
import API_URL from "../../api/url";
import { getToken , getMessaging } from "firebase/messaging";

import { getSavedDeviceToken, getSavedFCMToken , requestNotificationPermission } from "../../firebase";

export const Login = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
const messaging = getMessaging();
  const [filter, setFilter] = useState([]);
  const [logintoken, setLoginToken] = useState('');
  const [captchaValue, setCaptchaValue] = useState(null);
  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };


  const navigate = useNavigate();
  // var logintoken = ''
  async function getCsrfToken() {
    try {

      const uuidvar = uuid()

      const res = await createService(uuidvar);
      console.log("CsrfToken", res);
      const CsrfToken = res?.data?.csrfToken;
      const resf = await generateSessionToken(CsrfToken);
      // setLoginToken= resf.data.sessionToken
      setLoginToken(resf.data.sessionToken)
    }
    catch (e) {
      console.log(e, 'Error fetching CSRF token')

    }
  }

  useEffect(() => {
    getCsrfToken();
  }, []);

  const onCaptchaChange = (value) => {
    setCaptchaValue(value); // Capture reCAPTCHA token
  };


  // const onFinish = async (values) => {
  //   if (!captchaValue) {
  //     notification.error({
  //       message: "Error",
  //       description: "Please complete the captcha verification!",
  //     });
  //     return;
  //   }
  //   try {
  //     console.log("Received values of form ", values)
  //     if (values) {

  //       const fcmToken = getSavedFCMToken();
  //       const deviceToken = getSavedDeviceToken();
  //       const payload = {
  //         'loginId': values.loginId,
  //         'password': values.password,
  //         deviceToken : deviceToken , 
  //         fcmToken : fcmToken
  //       }
  //       const res = await login(payload, logintoken)

  //       if (res.status === 200) {
  //         navigate('/dashboard')
  //         notification.success({
  //           message: "Success",
  //           description: res.data.message || "Request completed successfully!",
           
           
  //         });
  //         localStorage.setItem('accesstoken', res?.data?.data?.accessToken);
  //         localStorage.setItem("login",res?.data?.data?.profile.name);
  //         localStorage.setItem("permission", JSON.stringify(res?.data?.data?.profile?.permissions));
          
  //         if(fcmToken){
  //           localStorage.setItem('fcm_token' , fcmToken)
  //         }
  //         if(deviceToken){
  //           localStorage.setItem('device_token' , deviceToken)
  //         }
  //         console.log(res?.data?.data?.profile.name, 'dshfkdjh')
  //       }
  //     }
  //   } catch (error) {
  //     console.log("Error during login", error)
  //   }
  // }


  const onFinish = async (values) => {
  if (!captchaValue) {
    notification.error({
      message: "Error",
      description: "Please complete the captcha verification!",
    });
    return;
  }

  try {
    // Initialize empty tokens
    let deviceToken = '';
    let fcmToken = '';

    try {
      // Request new notification permissions
      const permission = await Notification.requestPermission();
      if (permission === "granted") {
        // Get new FCM token
        fcmToken = await getToken(messaging, {
          vapidKey: "BCIt37hhH2rfFXcTrlUuakkVHjhVb7Sg7IP9KpTaKbBvQ0GPYVip3pRZT-RWmGmueVS2sAzWYQdIjf2O-YV_NX0",
        });
        
        // Generate new device token
        deviceToken = `${Date.now()}-${Math.random().toString(36).substring(2, 15)}`;
      }
    } catch (error) {
      console.error("Error getting tokens:", error);
      notification.warning({
        message: "Warning",
        description: "Notification permissions not granted. Some features may not work.",
      });
    }

    const payload = {
      loginId: values.loginId,
      password: values.password,
      deviceToken: deviceToken || '',
      fcmToken: fcmToken || ''
    };

    const res = await login(payload, logintoken);

    if (res.status === 200) {
      // Save tokens only after successful login
      if (deviceToken) {
        localStorage.setItem('device_token', deviceToken);
      }
      if (fcmToken) {
        localStorage.setItem('fcm_token', fcmToken);
      }

      // Save other auth data
      localStorage.setItem('accesstoken', res?.data?.data?.accessToken);
      localStorage.setItem("login", res?.data?.data?.profile.name);
  
       localStorage.setItem("userProfile", JSON.stringify(res?.data?.data?.profile));

      navigate('/dashboard');
      notification.success({
        message: "Success",
        description: res.data.message || "Login successful!",
      });
    }
  } catch (error) {
    console.log("Error during login", error);
    notification.error({
      message: "Login Failed",
      description: error.response?.data?.message || "Login failed. Please try again.",
    });
  }
};

  return (
    <>
      <div className="login-my-beauty">
       
        <div className="welcome-cont">
          <div className="first-login-img text-center">
            {/* <img src={IMAGES.BMBSimpleLogo} alt="" /> */}
          </div>

        </div>
        <div className="Login-Page">

          <div className="Login-Form">
            <Form
              name="login"
              initialValues={{
                remember: true,
              }}
              style={{
                // width: 550,
                backgroundColor: "#fff",
                padding: "50px",
                borderRadius: "20px",
                // boxShadow: "2px 2px 10px 2px #00000029",
              }}
              onFinish={onFinish}
            >
              <Row className="LogIn-BMB-Logo">
                {/* <h1>Welcome Back!</h1> */}
                {/* <h2>Login Your Account Details Here</h2> */}
              </Row>
              <Row className="LogIn-BMB-Logo">
                <img className="BMBLogo" src={IMAGES.BMBSimpleLogo} alt="" />
              </Row>

              <Form.Item
                label="Email"
                name="loginId"
                labelCol={{ span: 24 }}
                rules={[
                  {
                    required: true,
                    message: "Please enter your Email!",
                  },
                  {
                    type: "email",
                    message: "This is not valid E-mail!",
                  },
                ]}
              >
                <Input
                  size="large"
                  prefix={<UserOutlined />}
                  placeholder="Email"
                />
              </Form.Item>

              <Form.Item
                label="Password"
                name="password"
                labelCol={{ span: 24 }}
                rules={[
                  {
                    required: true,
                    message: "Please enter your Password!",
                  },
                ]}
              >
                <Input.Password
                  prefix={<LockOutlined />}
                  placeholder="Password"
                  size="large"
                />
              </Form.Item>
              <Form.Item>
                <ReCAPTCHA
                  sitekey="6Lf0Yq8qAAAAAJ1_k3t4VHYlXNLcBlNQTmS6T1Ry" 
                  onChange={onCaptchaChange}
                />
              </Form.Item>

              {/* <Form.Item>
                <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                  <a onClick={showModal}>Forgot password?</a>
                </div>
              </Form.Item> */}

              <Form.Item>
                <Button block size="large" type="primary" htmlType="submit">
                  Log in
                </Button>
              </Form.Item>
            </Form>
          </div>
        </div>
      </div>

      <ForgotPassword isModalOpen={isModalOpen} handleCancel={handleCancel} />
    </>
  );
};




